import React from 'react';
import { TextField, InputAdornment } from '@material-ui/core';
import { Controller, useFormContext } from 'react-hook-form';
import useIsFieldRequired from '../../../utility/useIsFieldRequired';

const RMSTextField = ({
  name,
  label,
  type = 'text',
  rows = 1,
  size = 'small',
  onBlur,
  onChange,
  leftContent,
  rightContent,
  InputProps,
  InputLabelProps,
  ...rest
}) => {
  const { control } = useFormContext();

  const isRequired = useIsFieldRequired(name);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          {...rest}
          label={label}
          variant="outlined"
          type={type}
          rows={rows}
          size={size}
          fullWidth
          required={isRequired}
          error={!!error}
          helperText={error?.message}
          value={field.value}
          onBlur={(event) => {
            field.onBlur();
            onBlur?.(event);
          }}
          onChange={(event) => {
            const value = event.target.value;
            field.onChange(value);
            onChange?.(value);
          }}
          InputLabelProps={{
            ...InputLabelProps,
            shrink: field.value !== '' && field.value !== null && field.value !== undefined,
          }}
          InputProps={{
            ...InputProps,

            startAdornment: (
              <>
                {leftContent && (
                  <InputAdornment position="start">
                    {typeof leftContent === 'function'
                      ? leftContent({
                          value: field.value,
                          onChange: field.onChange,
                        })
                      : leftContent}
                  </InputAdornment>
                )}

                {InputProps?.startAdornment}
              </>
            ),

            endAdornment: (
              <>
                {rightContent && (
                  <InputAdornment position="end">
                    {typeof rightContent === 'function'
                      ? rightContent({
                          value: field.value,
                          onChange: field.onChange,
                        })
                      : rightContent}
                  </InputAdornment>
                )}

                {InputProps?.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default RMSTextField;
